/**
 * A link that opens a page with Sabine's pane already open: how a chat in the
 * library or the Chats menu carries on where it happened. The page's coach
 * loads its saved thread itself (useSabineChatPersistence); this only asks
 * for the pane on arrival: the page's NavCoach reads the flag when it mounts,
 * and the nav opens the pane and drops the flag (useNavCoach).
 *
 * Client-safe.
 */
export const OPEN_SABINE_PARAM = "sabine";

/** `path` with the flag that opens Sabine's pane there. */
export function openSabineHref(path) {
  return `${path}${path.includes("?") ? "&" : "?"}${OPEN_SABINE_PARAM}=open`;
}

/** Did this page's address ask for Sabine's pane? Browser only. */
export function hasOpenSabineFlag() {
  return new URLSearchParams(window.location.search).get(OPEN_SABINE_PARAM) === "open";
}

/** Drop the flag from the address, so a reload does not open the pane again. */
export function clearOpenSabineFlag() {
  const url = new URL(window.location.href);
  url.searchParams.delete(OPEN_SABINE_PARAM);
  window.history.replaceState(window.history.state, "", url);
}
